<template>
  <div class="main-body position-relative">
    <vue-custom-scrollbar class="full-width full-height">
    <div class="nav-title ">
      
      <div  class="flex flex-center-cz margin-left-xl font-xl font-bold " style="width: 400px;">
          <span v-if="filter == ''" class="pointer no-wrap" @click="rootClick">个人空间</span>
          <span v-else >搜索结果</span>
          <div class="no-wrap"  v-if="filter == ''" v-for="(item,index) in navData" :key="index">
            <span class="margin-left-m">/</span>
            <span class="margin-left-m pointer" @click="navClick(item.id)">{{ item.name }}</span>
          </div>
      </div>

      <SearchInput :val="filter"  :placeholder="'请输入文档名或内容查询'" style="width: 300px;margin-top: 5px" @search="search"></SearchInput>

      <div class="flex flex-center-cz flex-end" style="width: 400px;">
        <!-- <div class="margin-right-l pointer" @click="listClick">
          <img v-if="viewMode == 'grid'" class="list-view-ico" src="@/assets/images/viewList-fill.png" />
          <img v-if="viewMode == 'list' " class="list-view-ico" src="@/assets/images/viewList-fill-2.png" />
        </div>
        <div class="margin-right-l pointer" @click="gridClick">
          <img v-if="viewMode == 'list' " class="grid-view-ico" src="@/assets/images/viewGrid-fill.png" />
          <img v-if="viewMode == 'grid'" class="grid-view-ico" src="@/assets/images/viewGrid-fill-2.png" />
        </div>
        <div v-if="false" class="margin-right-m blue-btn flex flex-center-cz flex-center-sp pointer cannotselect" @click="upFileClick">上传文件
        </div> -->
        <div class="margin-right-m blue-btn flex flex-center-cz flex-center-sp pointer" @click="createDirClick">创建文件夹</div>
        <div class="margin-right-xl blue-btn flex flex-center-cz flex-center-sp pointer cannotselect" @click="newFileClick">创建文件
        </div>

      </div>
    </div>

    <div style="min-height: 480px;">
      <div v-if="fileData != null && fileData.length == 0" style="margin-top: 50px;width: 95%;" class="flex flex-col flex-center-cz">
         <img style="width: 250px;height: 250px;" src="@/assets/images/empty-data.png"/>
         <div class="font-l">快来新建第一个文件吧</div>
         <div class="margin-top-l btn-blue-full border-radius-xxl pointer font-s w200" @click="newFileClick">新建文件</div>
      </div>
      <DocTable :fileData="fileData" v-if="viewMode == 'list' && fileData != null && fileData.length > 0" class="table-pnl padding-xl font-m"
        @change="tableChange" @itemClick="gridItemClick"></DocTable>
      <doc-grid :fileData="fileData" v-if="viewMode == 'grid' && fileData != null && fileData.length > 0" class="file-pnl" style="margin-top:45px;"
        @change="gridChange" @itemClick="gridItemClick">
      </doc-grid>
    </div>

    <div v-if="false" class="lesson flex flex-row margin-top-l">
      <div class="flex flex-center-cz margin-left-xl font-l font-bold">教程</div>
      <div class="flex flex-center-cz margin-left-m font-s color-rgb-05">新手入门，快速使用量子文档的方法都在这里～</div>
    </div>
    <doc-grid-a  v-if="false" :fileData="sysFileData" class="file-pnl"></doc-grid-a>

    <UpFile :show="showUpFile" @close="showUpFile = false" @change="addFile"></UpFile>
    <DocEditModal :open="showDocEditModal" @close="saveDocClose" :mdata="docData" :title="'新建'" 
                  @confirm="editDocConfirm" @refresh="updateDoc"></DocEditModal>
    <CreateFileConfirmModal ref="createFile" @confirm="createFileConfrim"></CreateFileConfirmModal>  
    <DocEditPlusModal :title="'创建'" ref="docEditPlusModal" @close="docEditPlusClose"></DocEditPlusModal>  

  </vue-custom-scrollbar>
  </div>
</template>
  
<script>
/*
      名称：主界面
      功能：
      作者：唐赢   
      时间：2022-11-30
*/


import PopupMenu from '@/components/popupMenu/PopupMenu'
import DocGrid from '@/modules/doc/DocGrid'
import DocGridA from '@/modules/doc/DocGridA'
import DocTable from '@/modules/doc/DocTable'
import UpFile from '@/modules/upFile/UpFile'
import {getDirData} from "@/utils/sysData.js"
import DocEditModal from '@/views/modal/DocEditModal'
import Mixin from '@/mixin/mixin';
import SearchInput from '@/components/searchInput/SearchInput.vue'
import { objToStr} from '@/utils/sysUtils.js'
import DocEditPlusModal from './modal/DocEditPlusModal.vue'


import {getDocList,getNav,uploadFile,addDoc, addDir, createDoc, getMyFile,
  getSysDocList,editDoc,getDocAllList, updateUserFile} from '@/api/api.js';

import CreateFileConfirmModal from './modal/CreateFileConfirmModal.vue'


export default {
  name: 'Person',
  components: {
    PopupMenu,
    DocGrid,
    DocGridA,
    DocTable,
    UpFile,
    DocEditModal,
    SearchInput,
    CreateFileConfirmModal,
    DocEditPlusModal
  },
  mixins:[Mixin],
  data() {
    return {
      filter:"",
      fileData: null,
      activeId: 0,
      sysFileData: null,
      navData: [],
      viewMode: 'grid',
      showUpFile: false,
      showDocEditModal: false,
      docData: null,
      saving: false,
      root: this,
    }
  },
  
  created() {

  },
  mounted() {

    if (sessionStorage.getItem("personNavData") && sessionStorage.getItem("personNavData") != "" ) {
      this.navData = JSON.parse(sessionStorage.getItem("personNavData"));
      this.activeId = sessionStorage.getItem("personNavId");
      sessionStorage.setItem("personNavData", "");
      sessionStorage.setItem("personNavId", "");
    }
    if (sessionStorage.getItem("person_filter") && sessionStorage.getItem("person_filter")  != "") {
      this.filter = sessionStorage.getItem("person_filter")
    }
    this.list();
    this.sysList();

  },
  methods: {

    search(value) {
      this.filter = value;
      sessionStorage.setItem("person_filter", value)
      this.list();

    },
    list() {
      this.$showLoading();
      if (this.filter != "") {
        getDocAllList(this.filter).then((res) => {
          this.$closeLoading();
          this.fileData = res.data.result;
        })
      } else {
        console.log("getDocList====", this.activeId)
        getDocList(this.activeId).then((res) => {
          this.$closeLoading();
          this.fileData = res.data.result.records;
          console.log("this.fileData ",this.fileData )
          this.$forceUpdate();
        })
      }
    },
    sysList() {
      getSysDocList().then((res) => {
        this.sysFileData = res.data.result;
      })
    },
    gridChange() {
      console.log("gridChange========")
      this.list();
      this.getNav(this.activeId);
    },
    tableChange() {
      this.list();
      this.getNav(this.activeId);
    },
    navClick(id) {
      this.activeId = id;
      this.list();
      this.getNav(id);
    },
    getNav(id) {
      this.navData = [];
      getNav(id).then((res) => {       
        this.navData = res.data.result;
        console.log("navData==", this.navData)
        this.$forceUpdate();
      })
    },
    gridItemClick(id) {
      let dir = getDirData(this.fileData, id);
      if (dir == null) return;
      if (dir.type == 1) {
        this.activeId = id;
        this.list();
        this.getNav(id);
      } else {
        console.log("this.acitveId ===", this.activeId )
        sessionStorage.setItem("personNavData", JSON.stringify(this.navData))
        sessionStorage.setItem("personNavId", this.activeId);
        this.$router.push({
          path: '/doc',
          query: {
            id: id 
          }
        })
      }
    },
    rootClick() {
      this.activeId = 0;
      this.list();
      this.navData = [];
    },
    newFileClick() {
      console.log("ok")
      this.$refs.createFile.open();

    },
    upFileClick() {
      this.showUpFile = true;
    },
    upFileClose() {
      this.showUpFile = false;
    },
    addFile(file) {
      if (file == null) return;
      this.$showLoading();
      uploadFile(file).then((res) => {
        if (res.data.success == true) {
          addDoc(file.name, res.data.result.file, this.activeId, res.data.result.cover).then((res) => {
            if (res.data.success == true) {
              this.$closeLoading(); 
              this.list();
              this.showUpFile = false;
            }
          }) 
        }      
      }) 
    },
    createDirClick() {
      this.$showInputBox({
        caption: "文件夹名",
        inputValue: '',
        callback: (data) => {
          addDir(data, this.activeId).then((res) => {
            this.list();
            this.$closeInputBox();    
          }) 
        }
      })
    },

    listClick() {
      this.viewMode = 'list';

    },
    gridClick() {
      this.viewMode = 'grid';
    },
    createFileConfrim(data) {
      this.$showLoading();
      createDoc(data.name, data.content, data.type, this.activeId).then((res) => {
          this.$closeLoading(); 
          if (res.data.success == true) { 
              getMyFile(res.data.result.id).then((res) => {
                this.$closeLoading();
                if (res.data.success == true) {   
                    this.docData = res.data.result;
                    if (this.docData.docType == "default") {
                      this.showDocEditModal = true;
                    } else {
                      this.$refs.docEditPlusModal.open(this.docData);
                    }

                } else {
                    return;           
                }
              })
          } else {
            this.$showToast({msg: res.data.message});
          }
      }) 
    },
    editDocConfirm(data) {
      this.$showLoading();
      data.sendMsg = 1;//修改发消息
      updateUserFile(data).then((res) => {
        this.$closeLoading(); 
          if (res.data.success == true) {
            this.docData = null;
            this.list();
            this.showDocEditModal = false;
          }  else {
            this.$showToast({msg: res.data.message});
          }           
      }) 
    },
    docEditPlusClose() {
      this.docData = null;
      this.list();
    },
    // editDocConfirmPlus(data) {
    //   this.$showLoading();
    //   data.sendMsg = 1;//修改发消息
    //   updateUserFile(data).then((res) => {
    //     this.$closeLoading(); 
    //       if (res.data.success == true) {
    //         this.docData = null;
    //         this.list();
    //         //this.showDocEditPlusModal = false;
    //       }  else {
    //         this.$showToast({msg: res.data.message});
    //       }           
    //   }) 
    // },

    // createDocConfirm(data) {
    //     this.$showLoading();
    //     if (!this.docData.id || this.docData.id == null ) {
    //         createDoc(data.name, data.content, data.docType, this.activeId).then((res) => {
    //             this.$closeLoading(); 
    //             if (res.data.success == true) { 
    //                 this.docData = null;
    //                 this.list();
    //                 this.showDocEditModal = false;
    //             } else {
    //               this.$showToast({msg: res.data.message});
    //             }
    //         })          
    //     } else {
    //         editDoc(this.docData.id, data.name, data.content).then((res) => {
    //             this.$closeLoading(); 
    //             if (res.data.success == true) {  
    //               this.docData = null;
    //               this.list(); 
    //               this.showDocEditModal = false;           
    //             } else {
    //               this.$showToast({msg: res.data.message});
    //             }
    //         })          
    //     }
    // },
    // saveDocData(data) {
    //   console.log("保存数据===", data )
    //   console.log("docData===", this.docData )
    //   if (this.saving == true) return false;
    //   this.saving = true;
    //   if (this.docData == null) {
    //       createDoc(data.name, data.content, data.docType, this.activeId).then((res) => {
    //           this.saving = false;
    //           if (res.data.success == true) {
    //             console.log("保存的id",  res.data.result.id);
    //             this.docData = res.data.result;
    //           }
    //       })          
    //   } else {
    //       editDoc(this.docData.id, data.name,  data.docType, data.content).then((res) => {
    //           this.saving = false;
    //           if (res.data.success == true) {   
    //             console.log("更新完成")           
    //           }
    //       })          
    //   }
    // },
    saveDocClose() {
      this.list();
      this.showDocEditModal = false;  

    },
    updateDoc(data) {
      this.docData = data;
    }
  }

}
</script>
  
    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
    
  


// WEBPACK FOOTER //
// src/views/Person.vue